import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const Outro = () => (
	<section id="outro">
		<section id="blurb" className="blurb">
			<h2>About</h2>
			<p>Hi, I&apos;m Vadim.
				I am a <a href="https://vu.nl/">VU Amsterdam</a> graduate currently working for <a href="https://resumedia.com">Resumedia</a>.
			</p>
			<ul className="actions">
				<li>
					{!window.location.pathname.includes('/resume') ? (
						<Link to="/resume" className="button">
							Learn More
						</Link>
					) : (
						<Link to="/about" className="button">
							About Me
						</Link>
					)}
				</li>
			</ul>
		</section>

		<section id="footer">
			<ContactIcons />
			<p className="copyright">&copy; Vadim Isakov <Link to="/">iaotle.dev</Link>.</p>
		</section>
	</section>
);

export default Outro;
